import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = {
  page: 1,
  limit: 11,
  totalPage: 2,

  productInfo: {},
  productList: [],
  storeCategoryList: [],
  productCategoryList: [],
  allProductCategoryList: []
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
